import PropTypes from 'prop-types';
import React from 'react';

import { Text, Link } from '@nerdwallet/currency';
import styles from './hero-nav-tile.module.less';

const HeroNavTile = (props) => {
  const makeTile = ({
    nav,
    IconComponent,
    iconColor,
    backgroundColor,
    url,
  }) => {
    return (
      <Link href={url} className={styles.container}>
        <div className={styles.tile}>
          <div style={{ backgroundColor }} className={styles.iconContainer}>
            <IconComponent
              color={iconColor}
              size={48}
              className={styles.iconComponent}
            />
          </div>
          <div className={styles.text}>
            <Text bold>{nav}</Text>
          </div>
        </div>
      </Link>
    );
  };

  return makeTile(props);
};

HeroNavTile.propTypes = {
  nav: PropTypes.string,
  IconComponent: PropTypes.elementType,
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  url: PropTypes.string,
};

HeroNavTile.displayName = 'HeroNavTile';

export default HeroNavTile;
